import styled from 'styled-components'

export const ValueWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 22px;
	padding-right: 4px;

	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`
